<template>
  <div name="demo-table-display">
    <hrms-table :columns="columns[nowLang].index"
                :data="index" />

    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :searchDisp="false"
                :tablePageDisp="false" />
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.approveLabels
let flgRowCondition = false
let mockColumns = mock.columns(labels, 'display', flgRowCondition)
let mockData = mock.dataApprove(flgRowCondition)

export default {
  name: 'demo-table-display',
  data () {
    return {
      nowLang: 'en',
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableDisplay.vue?2ecf9c3e